import { RESULT_OPTIONS } from "@/constants/report-result";
import React from "react";

import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const ReportToolbar = ({
  name,
  onNameChange,
  result,
  onResultChange,
}: {
  name: string;
  onNameChange: (name: string) => void;
  result?: string;
  onResultChange: (result?: string) => void;
}) => {
  const isFiltered = !!name || !!result;

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2">
        <Input
          placeholder="Search report name…"
          value={name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onNameChange(event.target.value);
          }}
          className="h-8 w-[150px] lg:w-[250px]"
        />

        <Select
          value={result ?? ""}
          onValueChange={(value) => onResultChange(value || undefined)}
        >
          <SelectTrigger size="sm" className="w-[110px]">
            <SelectValue placeholder="Result" />
          </SelectTrigger>
          <SelectContent>
            {RESULT_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {isFiltered && (
          <Button
            variant="ghost"
            onClick={() => {
              onNameChange("");
              onResultChange(undefined);
            }}
            className="h-8 px-2 lg:px-3"
          >
            Reset
            <XIcon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default ReportToolbar;
